import { useCallback } from 'react';

import { CalendarOutlined, FormOutlined } from '@ant-design/icons';
import { MenuProps } from 'antd';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { Outlet, useNavigate } from 'react-router-dom';

import { Sidenav } from '@/components/navigation/Sidenav';
import { ROUTES } from '@/config/routes';
import { DefaultLayout } from '@/layouts/DefaultLayout';

const routinesLink = ROUTES.getLink(`services`);
const catalogLink = ROUTES.getLink(`services.catalogo`);

const sidenavItems: ItemType[] = [
  { label: `Central de Rotinas`, key: routinesLink, icon: <CalendarOutlined /> },
  { label: `Catálogo`, key: catalogLink, icon: <FormOutlined /> },
];

// Demais Serviços as it was before moving into the IRM: its own menu, apart from the IRM menu.
export const ClassicServicesLayout = () => {
  const navigate = useNavigate();

  const handleSelectItem = useCallback<NonNullable<MenuProps['onClick']>>(
    (event) => navigate(event.key),
    [navigate],
  );

  return (
    <>
      <Sidenav items={sidenavItems} onSelectItem={handleSelectItem} />
      <DefaultLayout>
        <Outlet />
      </DefaultLayout>
    </>
  );
};
